import ThemePicker from './theme-picker';

export default ThemePicker;
